var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectedLocation != null
    ? _c(
        "div",
        { staticClass: "pl-0 mb-2" },
        [
          _vm.selectedLocation != null
            ? _c(
                "v-menu",
                {
                  attrs: {
                    transition: "slide-y-transition",
                    bottom: "",
                    "offset-y": ""
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  staticStyle: {
                                    "padding-left": "0px",
                                    "margin-left": "0px",
                                    "padding-right": "25px"
                                  },
                                  attrs: {
                                    color: "white",
                                    depressed: "",
                                    loading:
                                      !_vm.storeData || _vm.storeData.length < 1
                                  }
                                },
                                on
                              ),
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticStyle: { "margin-top": "-8px" },
                                    attrs: { size: "22", color: "#484848" }
                                  },
                                  [_vm._v("mdi-map-marker")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-inline",
                                    staticStyle: {
                                      "text-align": "left",
                                      color: "#999",
                                      "letter-spacing": "normal"
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "fs-12 text-capitalize",
                                        staticStyle: {
                                          "font-weight": "400",
                                          color: "#999"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.selectedLocation.storeName
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "v-icon",
                                          {
                                            staticStyle: {
                                              display: "inline-block",
                                              position: "absolute",
                                              "padding-left": "4px",
                                              "margin-top": "-8px",
                                              "font-size": "28px",
                                              color: "#a2a2a2"
                                            }
                                          },
                                          [_vm._v("mdi-chevron-down")]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "p",
                                      {
                                        staticClass: "fs-10 mb-0 warm-grey",
                                        staticStyle: {
                                          "text-align": "left",
                                          "font-size": "12px"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "text-transform": "capitalize",
                                              "font-weight": "400",
                                              color: "#999"
                                            }
                                          },
                                          [_vm._v("Device ID:")]
                                        ),
                                        _c(
                                          "strong",
                                          {
                                            staticStyle: {
                                              color: "#333",
                                              "letter-spacing": "normal",
                                              "font-weight": "500",
                                              "font-size": "11px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.selectedLocation.nasid)
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1062140772
                  )
                },
                [
                  _c(
                    "v-list",
                    {
                      staticStyle: {
                        "overflow-y": "scroll",
                        "overflow-x": "hidden",
                        padding: "0px !important"
                      },
                      attrs: { color: "#fffaf5", "max-height": "200px" }
                    },
                    _vm._l(_vm.storeData, function(location, index) {
                      return _c(
                        "v-list-item",
                        {
                          key: location.nasid,
                          style: {
                            "border-top": index == 0 ? "0px" : "solid 1px #ccc"
                          },
                          attrs: { dense: "" },
                          on: {
                            click: function($event) {
                              return _vm.selectLocation(location)
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-item-content",
                            { staticStyle: { padding: "0px 0px 0px 0px" } },
                            [
                              _c(
                                "v-list-item-title",
                                { staticStyle: { "min-height": "20px" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "fs-12 location-item",
                                      staticStyle: {
                                        "font-weight": "400",
                                        "text-transform": "capitalize"
                                      }
                                    },
                                    [_vm._v(_vm._s(location.storeName))]
                                  ),
                                  _vm.selectedLocation.nasid == location.nasid
                                    ? _c("img", {
                                        staticStyle: {
                                          height: "20px",
                                          float: "right",
                                          "margin-left": "10px",
                                          padding: "0px 5px",
                                          "margin-top": "-2px"
                                        },
                                        attrs: {
                                          src: require("img/icons/green-tick.svg")
                                        }
                                      })
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.selectedLocation == null || _vm.storeData == null
            ? _c("div", [_vm._v("Loading Locations")])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }